import createModuleSelectors from 'common/selectors/createModuleSelectors';

import defaultState from '../constants';

const surveyModuleSelectors = createModuleSelectors({
  moduleName: 'survey',
  defaultState,
});

export default surveyModuleSelectors;
